import { AnyAction } from 'redux';

import { PRODUCTS_RECEIVED, PRODUCTS_RECEIVE_DONE, PRODUCTS_RECEIVE_FAILED, PRODUCTS_REQUESTED } from '@ttstr/actions';
import { Articles } from '@ttstr/api';

export interface ReduxState {
  loading: boolean;
  products: Articles;
  productsReceived: boolean;
  error: Error;
}

const initialState: ReduxState = {
  loading: false,
  products: [],
  productsReceived: false,
  error: null,
};

const products = (state: ReduxState = initialState, action: AnyAction): ReduxState => {
  switch (action.type) {
    case PRODUCTS_REQUESTED: {
      return {
        ...state,
        loading: true,
      };
    }
    case PRODUCTS_RECEIVED: {
      const { products } = action.payload;

      return {
        ...state,
        productsReceived: true,
        products,
      };
    }
    case PRODUCTS_RECEIVE_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        error,
      };
    }
    case PRODUCTS_RECEIVE_DONE: {
      return {
        ...state,
        loading: false,
      };
    }
    default:
      return state;
  }
};

export default products;
